import initialState from "store/initialState";
import { SELECT_TILE } from "actions/selectedTile";

const selectedTile = (state = initialState.loading, action: any) => {
  switch (action.type) {
    case SELECT_TILE:
      return action.payload;
    default:
      return state;
  }
};

export default selectedTile;
